import { render, staticRenderFns } from "./TrocaExecutivos.vue?vue&type=template&id=23df139e"
import script from "./TrocaExecutivos.vue?vue&type=script&lang=js"
export * from "./TrocaExecutivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports